module.exports = __webpack_public_path__ + "img/home-totem.ed604370.svg";